// src/components/Navbar.js
import React, { useState } from 'react';
import './SideBarNavItem.css';
import { Link } from 'react-router-dom'
import { useSearchParams } from "react-router-dom";
function SideBarNavItem({code,title,link,icon}) {

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const app = searchParams.get("app")
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  //if coming from back end server applicaiton hide the header bar

  const [showNavBar, sethowNavBar] = useState(app == "besa" ? false:true);

  return (
    <Link to={link} >
    <div className="sidebar-nav-item" style={{}}>

        <div className='side-nav-item-icon' style={{display: 'inline-block'}}>
          <img src={`/Assets/Menu/${icon}.png`} alt={`${icon} icon`}  />
        </div>
        
          <h4 className='sidebar-nav-item-title' style={{display: 'inline-block'}}>{title}</h4>   
      
    </div>
      </Link>
  );
}

export default SideBarNavItem;

